// The agent opening an app.
//
// The engine's `open_app` tool resolves an app by its STABLE SYSTEM ID (OA-01 … OA-14) — the
// model is told those ids, so "open my CRM" is a lookup, not a guess. When it fires, the app
// mounts in the right-hand panel and the chat gains that app's tools.
//
// The panel already listens for OPEN_PLUGIN_PANEL_TAB_EVENT (session-plugin-apps-panel.tsx),
// so all this does is raise it. No new mechanism, no second way to open an app.

import { Icon } from "@openanalyst-ai/ui/icon"
import { ToolRegistry } from "@openanalyst-ai/ui/message-part"
import { createEffect, Show } from "solid-js"
import { useSDK } from "@/context/sdk"
import { emitOpenPluginPanelTab } from "@/pages/session/plugin-panel-tabs"

function OpenApp(props: { metadata: Record<string, unknown> }) {
  const sdk = useSDK()

  const id = () => (typeof props.metadata["id"] === "string" ? (props.metadata["id"] as string) : undefined)
  const systemId = () =>
    typeof props.metadata["systemId"] === "string" ? (props.metadata["systemId"] as string) : undefined
  const opened = () => props.metadata["opened"] === true

  createEffect(() => {
    const pluginID = id()
    if (!opened() || !pluginID || !sdk.directory) return
    // Raise the same event the app rail raises. The panel opens the app, and the agent can
    // work in it from the next turn.
    emitOpenPluginPanelTab({ directory: sdk.directory, pluginID })
  })

  return (
    <Show when={opened() && id()} fallback={<span data-open-app-missing="">That app isn’t available.</span>}>
      <div data-open-app="">
        <Icon name="window-cursor" />
        <span>
          Opened <b>{id()}</b>
          <Show when={systemId()}> ({systemId()})</Show>
        </span>
      </div>
    </Show>
  )
}

let registered = false

export function registerOpenAppTool() {
  if (registered) return
  ToolRegistry.register({
    name: "open_app",
    render(props) {
      return <OpenApp metadata={props.metadata as Record<string, unknown>} />
    },
  })
  registered = true
}

registerOpenAppTool()
